import { gatewaySchema, sensorSchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

type Response = z.infer<typeof responseSchema>;
const responseSchema = z.object({
  gateways: z.array(gatewaySchema),
  sensors: z.array(sensorSchema),
});

interface Params {
  search: string;
}

export function useDevices({ search }: Params) {
  const url = `/devices${objectToQueryParams({ search })}`;

  const { data, error, isLoading } = useQuery<Response>({
    queryKey: queryKeys.getDevices(search),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: search.length > 2,
  });

  return {
    gateways: data?.gateways || [],
    sensors: data?.sensors || [],
    error,
    isLoading,
  };
}
